/**
 * Debounces a function call. The returned function schedules `fn` to run after
 * `ms` milliseconds; subsequent calls within that window reset the timer.
 * Returns a `cancel` function to clear any pending call.
 */
export function debounce<Args extends unknown[]>(
  fn: (...args: Args) => void,
  ms: number,
): { call: (...args: Args) => void; cancel: () => void } {
  let timer: ReturnType<typeof setTimeout> | undefined
  return {
    call(...args: Args) {
      if (timer !== undefined) clearTimeout(timer)
      timer = setTimeout(() => fn(...args), ms)
    },
    cancel() {
      if (timer !== undefined) clearTimeout(timer)
      timer = undefined
    },
  }
}
